const lang = {
    actionButton: {
        confirm: 'موافق',
        cancel: 'إلغاء',
    },
};
export default lang;
